(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-sort]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('[data-gallery-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const showMedia = id => {
        if (!id || !section.querySelector(`[data-media-id="${id}"]`)) return;
        section.querySelectorAll('[data-media-id]').forEach(slide => {
          slide.hidden = slide.dataset.mediaId !== id;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
          else {
            const stage = section.querySelector('[data-adaptive-ratio]');
            if (stage) stage.style.aspectRatio = slide.dataset.imageRatio || '4 / 3';
          }
        });
        section.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
      };
      section.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
      const quantity = section.querySelector('[name="quantity"]');
      section.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        if (button.dataset.quantityChange === '1') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      const picker = section.querySelector('[data-variant-picker]');
      picker?.addEventListener('change', () => {
        const option = picker.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare]');
        compare.hidden = option.dataset.sale !== 'true';
        compare.textContent = option.dataset.compare;
        const add = section.querySelector('[data-add]');
        add.disabled = !available;
        add.textContent = available ? section.dataset.addLabel : section.dataset.soldLabel;
        section.querySelector('[data-payment]').hidden = !available;
        quantity.min = option.dataset.min;
        quantity.step = option.dataset.step;
        if (available && option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = option.dataset.min;
        showMedia(option.dataset.media);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
